import { useAtomValue } from 'jotai';
import { useState } from 'react';

import { SkeletonRect,Stack, Tabs } from '@ekhodealer/ekho-common/rev';

import type { TabItem} from '@ekhodealer/ekho-common/rev';

import { AccordionSection } from '@common/components/AccordionSection';

import { useGetInventoryItem } from '../../../api/useGetInventoryItem';
import { drawerAtom } from '../../../atoms/editDrawerAtoms';

// import { PricingHistory } from './PricingHistory';
import { PricingSettings } from './PricingSettings';

const PricingTab = {	
	SETTINGS: 'settings',
	HISTORY: 'history',
} as const;

type PricingTab = (typeof PricingTab)[keyof typeof PricingTab];

export const PricingDetails = () => {
	const { selectedItemId } = useAtomValue(drawerAtom);
	const { data: item, isLoading } = useGetInventoryItem(selectedItemId || '');
	const [activeTab, setActiveTab] = useState<PricingTab>(PricingTab.SETTINGS);

	// Show loading if actively loading OR if we have an ID but no data yet
	if (isLoading || Boolean(selectedItemId && !item)) {
		return (
			<AccordionSection title='Pricing' defaultExpanded>
				<Stack itemsSpacing='16'>
					<Stack itemsSpacing='12'>
						<SkeletonRect width='200px' height='20px' />
						<SkeletonRect width='100%' height='40px' />
						<SkeletonRect width='100%' height='40px' />
						<SkeletonRect width='150px' height='20px' />
						<SkeletonRect width='100%' height='40px' />
					</Stack>
				</Stack>
			</AccordionSection>
		);
	}

	const tabItems: TabItem[] = [
		{ id: PricingTab.SETTINGS, content: 'Settings' },
		// { id: PricingTab.HISTORY, content: 'History' },
	];

	const handleTabSelect = (item: TabItem) => {
		setActiveTab(item.id as PricingTab);
	};

	const renderTabContent = () => {
		return <PricingSettings />;
		// switch (activeTab) {
		// 	case PricingTab.SETTINGS:
		// 		return <PricingSettings />;
			// case PricingTab.HISTORY:
			// 	return <PricingHistory />;
		// }
	};

	return (
		<AccordionSection title='Pricing' defaultExpanded>
			<Stack itemsSpacing='16'>
				{tabItems.length > 1 && (
				<Tabs
					items={tabItems}
					selectedKey={activeTab}
					onSelect={handleTabSelect}
				/>
				)}
				{renderTabContent()}
			</Stack>
		</AccordionSection>
	);
};
